export default {
  access_setDashboardAccess(state, access) {
    state.access_dashboards = access
  },
}
